import { combineReducers } from 'redux';
import { reducer as list } from './listModule';

export default combineReducers({
	list,
});
